import z from "zod"

export const demographicsSchema = z
  .object({
    critical_incident_occurred: z.boolean(),
    critical_incidents: z.array(z.string()),
    cald_backgrounds: z.array(z.string()),
  })
  .superRefine((val, ctx) => {
    if (val.critical_incident_occurred && val.critical_incidents.length < 1) {
      ctx.addIssue({
        code: "custom",
        message:
          "Please tick any incidents that apply so we can prepare appropriately",
        path: ["critical_incidents"],
      })
    }
  })
